<pdf-viewer [src]="pdfUrl"
[render-text]="true"
[original-size]="false"
style="width: 100%; height: 10000px"
></pdf-viewer>
